import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export default function usePermissions() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    function useList() {
        return useQuery({
            queryKey: ["permissions"],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/permissions/");
                return parseSuccessResponseData(response);
            },
        });
    }

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: { Id: string; Name: string; Description?: string }) =>
                axiosPrivate.post("/v1/permissions/", parameters).then(parseSuccessResponseData),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["permissions"] });
            },
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: (parameters: { Id: string; Name?: string; Description?: string }) =>
                axiosPrivate.put("/v1/permissions/", parameters).then(parseSuccessResponseData),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["permissions"] });
            },
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: (parameters: { Id: string }) =>
                axiosPrivate.delete(`/v1/permissions/${parameters.Id}`).then(parseSuccessResponseData),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["permissions"] });
            },
        });
    }

    return { useList, useCreate, useUpdate, useDelete };
}
